import { toUnicode } from 'punycode';
import { pluralize } from '../../../../../utils/pluralize';
import { Flex } from '../../../../layout/Flex';
import { Image } from '../../../../media/Image';
import { MediaCover } from '../../../../media/MediaCover';
import { Typography } from '../../../../typography/Typography';
import { AdvertisingProductCardSourceProps } from './types';

export const AdvertisingProductCardSource: React.FC<AdvertisingProductCardSourceProps> = ({
    offers,
}) => {
    const offersCount = offers.length;

    if (offersCount > 1) {
        return (
            <Typography variant="caption" color="secondary" width="100%" noWrap>
                {`${offersCount} ${pluralize(offersCount, 'магазин', 'магазина', 'магазинов')}`}
            </Typography>
        );
    }

    const firstOffer = offers[0];
    const hostname = firstOffer.url ? new URL(firstOffer.url).hostname : undefined;
    const hostnameText = hostname && toUnicode(hostname);
    const favicon = hostname && `//favicon.yandex.net/favicon/v2/${hostname}?size=32&stub=1`;

    return (
        <Flex direction="row" alignItems="center" spacing={0.5} width="100%" overflow="hidden">
            <Flex flexShrink={0}>
                <MediaCover
                    ratio={1}
                    overflow="hidden"
                    borderRadius={3}
                    border="1px solid var(--placeholder)"
                    backgroundColor="unset"
                    width="14px"
                    height="14px"
                >
                    <Flex alignItems="center" justifyContent="center" backgroundColor="white">
                        <Image objectFit="contain" width="100%" height="100%" src={favicon} />
                    </Flex>
                </MediaCover>
            </Flex>
            <Typography
                variant="caption"
                color="secondary"
                noWrap
                overflow="hidden"
                textOverflow="ellipsis"
            >
                {hostnameText}
            </Typography>
        </Flex>
    );
};
